import GeoscapeDeveloperSvg from "icons/hub-logo-signIn.svg?react";

import { useTheme } from "@/components/theme-provider";

/**
 * Shared chrome for the logged-out auth pages: the Geoscape logo above a
 * centered card. Used by sign-in, reset-password and resend-verification.
 */
export const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const { resolvedTheme } = useTheme();
  const isDark = resolvedTheme === "dark";

  return (
    <div className="flex flex-col items-center justify-center gap-5">
      <GeoscapeDeveloperSvg
        fill={isDark ? "white" : "black"}
        className="h-20"
      />
      {children}
    </div>
  );
};
